import React from 'react';

const SvgTelegram = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
    {...props}
  >
    <path
      d="M8.5 0C4.08 0 .5 3.58.5 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8Zm3.93 5.47-1.31 6.17c-.1.44-.36.54-.72.34l-2-1.47-1 .93c-.1.1-.19.19-.4.19l.14-2.04 3.73-3.37c.16-.15-.04-.23-.25-.08l-4.61 2.9-1.98-.62c-.43-.13-.44-.43.09-.64l7.75-2.99c.36-.13.68.09.56.64v.04Z"
      fill="currentColor"
    />
  </svg>
);

export default SvgTelegram;
